import { render, staticRenderFns } from "./ControllerCabinet.vue?vue&type=template&id=c9ffbca4&lang=pug&"
import script from "./ControllerCabinet.vue?vue&type=script&lang=js&"
export * from "./ControllerCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports